import { render } from "./PageSignUpStudent.vue?vue&type=template&id=6b6e61f0"
import script from "./PageSignUpStudent.vue?vue&type=script&lang=js"
export * from "./PageSignUpStudent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__